import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import {computed, ref, watch} from 'vue';
import {IWidgetPaymentTabContent} from "~/chat/ts/data/ITab";
import {ConfigStore} from "~/chat/ts/store/Config";
import {WIDGET_SERVER} from "~/chat/ts/CommonConstants";
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import ChatClickableBlock from "~/chat/vue/widget/form/fields/ChatClickableBlock.vue";
import {IPaymentSystemSelectorModel} from "~/chat/vue/widget/tabs/payment/PaymentFormInterface";

interface IPaymentSystem {
    id: string,
    descr: string,
    logo: string
}

const __default__ = {
    name: "PaymentSystemSelector"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    content: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let model = ref<IPaymentSystemSelectorModel>();

let dialog = ref<{
    visible: boolean,
    paymentSystems: IPaymentSystem[]
}>();

function selectPaymentSystemId(paymentSystemId: string) {
    model.value.paymentSystemId = paymentSystemId;
    emitInput();
}

function selectPaymentSystemType(typeId: string, paymentSystems: IPaymentSystem[]) {
    model.value = {
        typeId
    };

    if (paymentSystems.length == 1) {
        model.value.paymentSystemId = paymentSystems[0].id;
        emitInput();
    } else {
        dialog.value = {
            visible: true,
            paymentSystems
        };
    }
}

function emitInput() {
    emits("input", ObjectHelper.jsonClone(model.value));
}


function checkPaymentSystemsCount() {
    let result = paymentSystems.value;
    if (result.length == 1) {
        selectPaymentSystemType(result[0].typeId, result[0].paymentSystems);
    }
}


let paymentSystems = computed(() => {
    let result: {
        typeId: string,
        typeDescr: string,
        logo: string,
        paymentSystems: IPaymentSystem[]
    }[] = [];
    let paymentTypes = props.content.paymentTypes;
    for (let typeId in paymentTypes) {
        if (paymentTypes.hasOwnProperty(typeId)) {
            let typeDescr = ConfigStore.siteParams.value.paymentSystemTypes[typeId];
            if (typeDescr) {
                let paymentSystems: IPaymentSystem[] = [];
                for (let paymentSystemId of paymentTypes[typeId]) {
                    let paymentSystem = ConfigStore.siteParams.value.paymentSystems[paymentSystemId];
                    if (paymentSystem) {
                        paymentSystems.push({
                            id: paymentSystemId,
                            descr: paymentSystem.descr,
                            logo: `${WIDGET_SERVER}/images/paymentSystems/${paymentSystemId}.png`,
                        });
                    }
                }
                if (paymentSystems.length) {
                    result.push({
                        typeId,
                        typeDescr,
                        logo: `${WIDGET_SERVER}/images/paymentSystems/${typeId}.png`,
                        paymentSystems: paymentSystems
                    });
                }
            }
        }
    }

    return result;
});

checkPaymentSystemsCount();

watch(paymentSystems, () => checkPaymentSystemsCount(), {deep: true});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentSystems), (item) => {
      return (_openBlock(), _createBlock(ChatClickableBlock, {
        key: item.typeId,
        onClick: ($event: any) => (selectPaymentSystemType(item.typeId, item.paymentSystems))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: item.logo,
              class: "logo"
            }, null, 8, _hoisted_1)
          ]),
          _createTextVNode(" " + _toDisplayString(item.typeDescr), 1)
        ]),
        _: 2
      }, 1032, ["onClick"]))
    }), 128)),
    (_unref(dialog) && _unref(dialog).visible)
      ? (_openBlock(), _createBlock(ChatModalMessage, {
          key: 0,
          visible: _unref(dialog).visible,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).visible) = $event)),
          title: "Выберите платёжную систему"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialog).paymentSystems, (item) => {
              return (_openBlock(), _createBlock(ChatClickableBlock, {
                key: item.id,
                onClick: ($event: any) => (selectPaymentSystemId(item.id))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: item.logo,
                      class: "logo"
                    }, null, 8, _hoisted_2)
                  ]),
                  _createTextVNode(" " + _toDisplayString(item.descr), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})